/**
 * @function apiFetch
 * @description Fetches data from an API endpoint
 *
 * @async
 * @return {void}
 */
export default async function apiFetch(
    endpoint,
    method,
    data = null,
    type = ''
) {
    const headers = new Headers({ 'X-Requested-With': 'XMLHttpRequest' });
    const args = { method, headers };

    if (type === 'json') {
        headers.set('Content-Type', 'application/json');
        data = data !== null ? JSON.stringify(data) : null;
    }

    if (type === 'urlencoded') {
        headers.set('Content-Type', 'application/x-www-form-urlencoded');
        data = data !== null ? new URLSearchParams(data).toString() : null;
    }

    if (method !== 'GET' && data !== null) {
        args.body = data;
    }

    try {
        const response = await fetch(endpoint, args);

        if (response.ok) {
            const data = await response.json();

            return data;
        } else {
            throw response.statusText;
        }
    } catch (error) {
        console.error(error);
        return { error: true, message: error };
    }
}
